import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input } from 'reactstrap';

export default class References extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input name='name' required maxLength="50" value={this.props.item.name || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Relationship</Label>
                            <Input name='relationship' required maxLength="50" value={this.props.item.relationship || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Phone Number</Label>
                            <Input name='phoneNumber' maxLength='25' required pattern='^[2-9]\d{2}\d{3}\d{4}$|^[2-9]\d{2}-\d{3}-\d{4}$|^\d{12}$' placeholder="###-###-####" value={this.props.item.phoneNumber || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}